const RangeFilter = ({
  filterType,
  setFilterType,
  minValue,
  setMinValue,
  maxValue,
  setMaxValue,
  resetFilter,
  applyFilter,
}) => {
  return (
    <div className="tw-flex max-lg:tw-flex-col tw-w-full tw-mx-auto !tw-text-sm tw-my-2">
      {/* Filter Type Buttons */}
      <div className="tw-flex max-lg:tw-justify-center tw-gap-2 tw-me-2 max-lg:tw-me-0 tw-h-10">
        {[
          { label: "Greater Than", value: "greater" },
          { label: "Less Than", value: "less" },
          { label: "Between", value: "between" },
        ].map(({ label, value }) => (
          <button
            key={value}
            onClick={() => setFilterType(value)}
            className={`tw-px-1 tw-w-[110px] max-lg:tw-w-full !tw-m-0 !tw-rounded-md tw-py-1 tw-border ${
              filterType === value
                ? "tw-bg-primary tw-text-white"
                : "tw-bg-gray-100"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="tw-flex tw-w-full max-lg:tw-mt-2">
        {/* Input Fields Based on Filter Type */}
        {filterType === "greater" && (
          <input
            type="number"
            placeholder="Enter minimum value"
            value={minValue}
            onChange={(e) => setMinValue(e.target.value)}
            className="tw-p-2 tw-border tw-rounded"
          />
        )}

        {filterType === "less" && (
          <input
            type="number"
            placeholder="Enter maximum value"
            value={maxValue}
            onChange={(e) => setMaxValue(e.target.value)}
            className="tw-w-full tw-p-2 tw-border tw-rounded tw-mb-4"
          />
        )}

        {filterType === "between" && (
          <div className="tw-flex tw-gap-2 tw-w-full ">
            <input
              type="number"
              placeholder="Min"
              value={minValue}
              onChange={(e) => setMinValue(e.target.value)}
              className="tw-w-1/2 tw-p-2 tw-border tw-rounded"
            />
            <input
              type="number"
              placeholder="Max"
              value={maxValue}
              onChange={(e) => setMaxValue(e.target.value)}
              className="tw-w-1/2 tw-p-2 tw-border tw-rounded"
            />
          </div>
        )}

        {/* Action Buttons */}
        <div className="tw-flex tw-justify-between tw-ms-2">
          <button
            onClick={applyFilter}
            className="tw-bg-primary tw-text-white tw-px-4 tw-py-2 !tw-rounded-md hover:tw-bg-primaryLight"
          >
            Apply
          </button>
          <button
            onClick={resetFilter}
            className="tw-bg-gray-300 tw-text-gray-800 tw-px-4 tw-py-2 !tw-rounded-md hover:tw-bg-gray-400"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default RangeFilter;
